export default function SectionHeading({ eyebrow, title, text, align = '' }) {
  return (
    <div className={`section-heading ${align}`}>
      {eyebrow && <span className="eyebrow">{eyebrow}</span>}
      <h2>{title}</h2>
      {text && <p>{text}</p>}
    </div>
  );
}